import React from "react";

const AdminLayout = ({ children, activeTab, setActiveTab }) => {
  return (
    <div className="min-h-screen bg-[#fafafa]" style={{ fontFamily: '"Libre Franklin", sans-serif' }}>
      {/* FontAwesome CDN */}
      <link 
        rel="stylesheet" 
        href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css" 
        integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw==" 
        crossOrigin="anonymous" 
        referrerPolicy="no-referrer" 
      />
      
      {/* Header */}
      <header className="bg-white shadow-sm border-b border-gray-100">
        <div className="f-section mx-auto px-4 py-8">
          <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
            <div>
              <h1 className="dark-header !text-[#000] !mb-2">Real Estate Admin</h1>
              <p className="light-header">Professional property management platform</p>
            </div>
            <div className="flex items-center space-x-6">
              <div className="flex items-center space-x-3">
                <div className="w-10 h-10 bg-gradient-to-br from-[#10c9c0] to-[#0eb1a9] rounded-xl flex items-center justify-center">
                  <i className="fas fa-user text-white"></i>
                </div>
                <div>
                  <p className="font-medium text-[#000]">Welcome back</p>
                  <p className="light-header !mb-0">Professional Agent</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </header>

      {/* Navigation */}
      <nav className="bg-white border-b border-gray-100 sticky top-0 z-40">
        <div className="f-section mx-auto px-4">
          <div className="flex space-x-8 overflow-x-auto">
            {[
              { id: 'dashboard', label: 'Dashboard', icon: 'fas fa-chart-line' },
              { id: 'listings', label: 'Listings', icon: 'fas fa-home' },
              { id: 'profile', label: 'Profile', icon: 'fas fa-user-cog' }
            ].map((tab) => (
              <button
                key={tab.id}
                onClick={() => setActiveTab(tab.id)}
                className={`flex items-center py-4 px-2 border-b-2 font-medium text-sm transition-all duration-300 whitespace-nowrap ${
                  activeTab === tab.id
                    ? 'border-[#10c9c0] text-[#10c9c0]'
                    : 'border-transparent text-[#949995] hover:text-[#000] hover:border-gray-300'
                }`}
              >
                <i className={`${tab.icon} mr-2`}></i>
                {tab.label}
              </button>
            ))}
          </div>
        </div>
      </nav>

      {/* Main Content */}
      <main className="f-section mx-auto px-4 py-8">
        {children}
      </main>
    </div>
  );
};

export default AdminLayout;